import { Injectable, signal } from '@angular/core';
import { ToastConfig } from '@targx/components/tx-toast/types';

@Injectable({ providedIn: 'root' })
export class ToastService {
  private readonly _toasts = signal<ToastConfig[]>([]);

  /** Read-only signal of active toasts */
  readonly toasts = this._toasts.asReadonly();

  /**
   * Display a toast notification.
   * Returns the generated ID so you can dismiss it programmatically.
   */
  show(config: ToastConfig): string {
    const id = crypto.randomUUID();
    const toast: ToastConfig = { ...config, id, duration: config.duration ?? 12000 };
    this._toasts.update(list => [...list, toast]);

    if (toast.duration && toast.duration > 0) {
      setTimeout(() => this.dismiss(id), toast.duration);
    }

    return id;
  }

  /** Remove a toast by ID */
  dismiss(id: string): void {
    this._toasts.update(list => list.filter(t => t.id !== id));
  }

  /** Remove all active toasts */
  dismissAll(): void {
    this._toasts.set([]);
  }
}
